export default "__VITE_ASSET__B3iD9zic__"